import { toast } from "react-toastify";

export const successMsg = (mgs) => {
  return toast.success(mgs + ".", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
